import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { showSnackBar } from "../../redux/action/snackActions";

import SmartTable from "../../components/common/SmartTable";
import CommonAddModal from "../../components/common/Modals/CommonAddModal";
import DeleteModal from "../../components/common/Modals/DeleteModal";

import EditCommonAction from "../../components/common/Actions/EditAction";
import AddCommonAction from "../../components/common/Actions/AddCommonAction";
import DeleteCommonAction from "../../components/common/Actions/DeleteCommonAction";
import getErrorMessage from "../../helpers/getErrorMessage";
import { createItemAvailability, getAllItemAvailability, updateItemAvailability, deleteItemAvailability } from "../../redux/action/itemAvailability";
import { createVendor, deleteVendor, getvendors, updateVendor } from "../../redux/action/vendorAdctions";

const PageTitle = "Vendor Master";
const vendorTypes = ["Raw Material", "Utility", "Rental", "Asset", "Service Provider", "Aggregator"].map(type => ({ label: type, value: type }));
const paymentMode = ["NEFT", "UPI", "Cheque", "Cash"].map(type => ({ label: type, value: type }));
const paymentTerms = [
  "100% Advance",
  "50% Advance, 50% on delivery",
  "Cash on Delivery",
  "7 days after Goods Receipt",
  "15 days after Goods Receipt",
  "30 days after GR",
  "Weekly(Every Monday)",
  "Biweekly(on 1st and 16th)",
  "Monthly(1st Date)"
].map(term => ({
  label: term,
  value: term
}));

const VendorMaster = () => {
  const { vendor } = useSelector((state) => state.common);
  const { branchId, actionLockSetting } = useSelector((state) => state.user);

  const formData = [
    {
      type: "text",
      name: "vendorName",
      label: "Vendor Name",
      size: 4,
      required: true,
      rules: {
        required: {
          value: true,
          message: "Meal Name is required",
        },
      },
    },

    {
      type: "select",
      name: "vendorType",
      label: "Vendor Type",
      size: 4,
      options: vendorTypes,
      optionLabelProp: "label",
      optionValueProp: "value",
      defaultOption: () => (
        <option selected disabled>
          Select Vendor Type
        </option>
      ),
    },

    {
      type: "text",
      name: "contactPerson",
      label: "Contact Person Name",
      size: 4,
    //   required: true,
    //   rules: {
    //     required: {
    //       value: true,
    //       message: "Contact Person Name is required",
    //     },
    //   },
    },

    {
      type: "text",
      name: "contactNumber",
      label: "Contact Mobile Number",
      size: 4,
    //   required: true,
    //   rules: {
    //     required: {
    //       value: true,
    //       message: "Contact Mobile Number is required",
    //     },
    //   },
    },

    {
      type: "text",
      name: "contactEmailId",
      label: "Contact Email ID",
      size: 4,
    //   required: true,
    //   rules: {
    //     required: {
    //       value: true,
    //       message: "Contact Email ID is required",
    //     },
    //   },
    },

    {
      type: "text",
      name: "panNumber",
      label: "PAN Number",
      size: 4,
    //   required: true,
    //   rules: {
    //     required: {
    //       value: true,
    //       message: "PAN Number is required",
    //     },
    //   },
    },

    {
      type: "text",
      name: "gstNumber",
      label: "GSTIN (GST Number)",
      size: 4,
    //   required: true,
    //   rules: {
    //     required: {
    //       value: true,
    //       message: "GSTIN (GST Number) is required",
    //     },
    //   },
    },

    {
      type: "text",
      name: "fssaiNumber",
      label: "FSSAI Number",
      size: 4,
    //   required: true,
    //   rules: {
    //     required: {
    //       value: true,
    //       message: "FSSAI Number is required",
    //     },
    //   },
    },

    {
      type: "text",
      name: "address",
      label: "Billing Address",
      size: 4,
    //   required: true,
    //   rules: {
    //     required: {
    //       value: true,
    //       message: "Billing Address is required",
    //     },
    //   },
    },

    {
      type: "text",
      name: "upiId",
      label: "UPI ID",
      size: 4,
    //   required: true,
    //   rules: {
    //     required: {
    //       value: true,
    //       message: "UPI ID is required",
    //     },
    //   },
    },

    {
      type: "select",
      name: "paymentMode",
      label: "Payment Mode",
      size: 4,
      options: paymentMode,
      optionLabelProp: "label",
      optionValueProp: "value",
      defaultOption: () => (
        <option selected disabled>
          Select Payment Mode
        </option>
      ),
    },

    {
      type: "select",
      name: "paymentTerm",
      label: "Payment Term",
      options: paymentTerms,
      size: 4,
      optionLabelProp: "label",
      optionValueProp: "value",
      defaultOption: () => (
        <option selected disabled>
          Select Payment Term
        </option>
      ),
    },

    {
      type: "text",
      name: "document",
      label: "Upload Document",
      size: 4,
    },

    {
      type: "select",
      name: "status",
      label: "Vendor Status",
      size: 4,
      options: [
        {
          title: "Active",
          value: true
        },
        {
          title: "Inactive",
          value: false
        },
      ],
      optionLabelProp: "title",
      optionValueProp: "value",
      defaultValue: true,
    },
  ];

  const dispatch = useDispatch();

  const [open, setOpen] = React.useState();
  const [actionData, setActionData] = React.useState();

  const toggleAdd = (mode) => {
    setOpen(mode);
    if (mode === undefined) {
      setActionData({});
    }
  };

  const onAdd = (data) => {
    // console.log(data);
    if(open === "Add"){
      dispatch(createVendor({...data}))
      .then((res) => {
        if (res.payload.status === 200) {
          dispatch(showSnackBar("Vendor Created succesfully"));
        } else {
          dispatch(
            showSnackBar(
              getErrorMessage(res) || "Failed to Create",
              "error"
            )
          );
      }
    });
    }
    else if(open === "Edit"){
      dispatch(updateVendor(data))
      .then((res) => {
        if (res.payload.status === 200) {
          dispatch(showSnackBar("Vendor Updated succesfully"));
        } else {
          dispatch(
            showSnackBar(
              getErrorMessage(res) || "Failed to Create",
              "error"
            )
          );
      }
    });
    }
    dispatch(getvendors())
    toggleAdd();
  };

  const AddAction = () => {
    return (
      <AddCommonAction onClick={() => toggleAdd("Add")} title={PageTitle} />
    );
  };

  const handleEdit = (data) => {
    toggleAdd("Edit");
    setActionData(data);
  };

  const handleDelete = (data) => {
    toggleAdd("Delete");
    setActionData(data);
  };

  const confirmDelete = () => {
    // console.log(actionData)
    dispatch(deleteVendor(actionData.id))
    .then((res) => {
      if (res.payload.status === 200) {
        toggleAdd();
        dispatch(showSnackBar("Vendor Deleted succesfully"));
        dispatch(getvendors())
      } else {
        dispatch(
          showSnackBar(
            getErrorMessage(res) || "Failed to Create",
            "error"
          )
        );
    } 
    });
  };

  const EditAction = (action) => (
    <EditCommonAction onClick={() => handleEdit(action.data)} />
  );

  const DeleteAction = (action) => (
    <DeleteCommonAction onClick={() => handleDelete(action.data)} />
  );

  const headers = [
    {
      title: "Vendor Name",
      key: "vendorName",
    },

    { title: "Vendor Type", key: "vendorType" },
    { title: "Contact Person", key: "contactPerson" },
    { title: "Mobile Number", key: "contactNumber" },
    { title: "Vendor Status", key: "status" },
  ];

  const defaultValues = {
  };

  React.useEffect(() => {
    dispatch(getvendors());
  }, [open]);

  return (
    <>
      <div class="page-content-tab">
        <CommonAddModal
          title={PageTitle}
          open={open === "Add" || open === "Edit"}
          onClose={() => toggleAdd()}
          mode={open}
          onSubmit={(e) => onAdd(e)}
          data={actionData}
          formData={formData}
          defaultValue={defaultValues}
        />
        <DeleteModal
          size="md"
          open={open === "Delete"}
          title={actionData?.name}
          onClose={() => toggleAdd()}
          onConfirm={() => confirmDelete()}
        />
        <SmartTable
          title={PageTitle}
          paginated={true}
          headActions={[AddAction]}
          actions={actionLockSetting ? [] : [EditAction, DeleteAction]}
          tableData={vendor}
          headers={headers}
        />
      </div>
    </>
  );
};

export default VendorMaster;
